
export default {
  name: 'LayoutHeader',
  data() {
    return {
      isMobileMenuOpen: false,
    }
  },
}
